<header
  #siteHeader
  class="site-header"
  [ngClass]="getClass(bootstrapConfig$ | async)"
  [ngSwitch]="(bootstrapConfig$ | async)?.getCompanyTypeString()">
  <agency-site-header-content
    class="block h-full"
    *ngSwitchDefault></agency-site-header-content>
  <client-site-header-content
    class="block h-full"
    *ngSwitchCase="'CLIENT'"></client-site-header-content>
  <legal-site-header-content
    class="block h-full"
    *ngSwitchCase="'LEGAL'"></legal-site-header-content>
</header>
